import {
  Home,
  Circle,
  Star,
  CheckSquare,
  Calendar,
  Award,
  User,
  HelpCircle,
  Zap
} from "react-feather"

export default [
  {
    id: "dashboard",
    title: "Dashboard",
    icon: <Home size={20} />,
    navLink: "/dashboard",
    action: "read",
    resource: "Dashboard"
  },
  {
    id: "todo",
    title: "Todo",
    action: "read",
    resource: "Todo",
    icon: <CheckSquare size={20} />,
    navLink: "/apps/todo"
  },
  {
    id: "calendar",
    title: "Calendar",
    action: "read",
    resource: "Calendar",
    icon: <Calendar size={20} />,
    navLink: "/apps/calendar"
  },
  {
    id: "contest-read",
    title: "Contests",
    action: "read",
    resource: "Contests",
    icon: <Award size={20} />,
    navLink: "/apps/contests"
  },
  {
    id: "contest-create",
    title: "Create Contest",
    action: "write",
    resource: "Contests",
    icon: <Zap size={20} />,
    navLink: "/apps/contests/create"
  },
  {
    id: "accountSettings",
    action: "read",
    resource: "Settings",
    title: "Account Settings",
    icon: <User size={12} />,
    navLink: "/pages/account-settings"
  },
  {
    id: "faq",
    action: "read",
    resource: "FAQ",
    title: "Help Center",
    icon: <HelpCircle size={12} />,
    navLink: "/pages/faq"
  },
  {
    id: "upgrade",
    action: "read",
    resource: "Upgrade",
    title: "Upgrade",
    icon: <Star size={12} />,
    externalLink: true,
    navLink: "https://www.earnify.io/book-demo"
  }
]
